import { buildSectionRenameUpdate } from '@griply/services';
import { useCallback } from 'react';
import { Goal } from 'shared/types/goal';
import { ID } from 'shared/types/id';

import { useUpdateGoal } from './use-update-goal';

export const useRenameGoalSection = () => {
  const { submit: updateGoal } = useUpdateGoal();

  return useCallback(
    (goal: Goal, sectionId: ID, name: string) => {
      if (!goal.sections) {
        return;
      }

      updateGoal(buildSectionRenameUpdate(goal, sectionId, name));
    },
    [updateGoal],
  );
};
